import { $t } from "@/plugins/i18n";
import { scriptLibrary } from "@/router/enums";
import scriptLibraryIcon from "@/assets/svg/scriptLibrary.svg?component";
export default {
  path: "/scriptLibrary",
  redirect: "/scriptLibrary/index",
  meta: {
    icon: scriptLibraryIcon,
    title: $t("menus.scriptLibrary"), // 建议多语言
    rank: scriptLibrary
  },
  children: [
    {
      path: "/scriptLibrary/index",
      name: "ScriptLibrary",
      component: () => import("@/views/scriptLibrary/index.vue"),
      meta: {
        title: $t("menus.scriptLibrary"),
        showLink: false
        // keepAlive: false
      }
    }
  ]
} satisfies RouteConfigsTable;
